angular.module('bribac.components.modelMinutesAsSeconds', [])

  // Converts a Number value between minutes in the view and seconds in the model.

  .directive('modelMinutesAsSeconds', function() {
    function converterFactory(scaleDown) {
      return function converter(value) {
        if (typeof value !== 'undefined') {
          if (typeof value === 'number') {
            return scaleDown ? value / 60 : value * 60
          }
          return value
        }
      }
    }

    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ngModelCtrl) {
        // From Model to Input.
        ngModelCtrl.$formatters.push(converterFactory(true))
        // From Input to Model.
        ngModelCtrl.$parsers.push(converterFactory(false))
      }
    }
  })
